
import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { TextAnalysisHeader } from "@/components/headers/textAnalysisHeader";
import { TextInput } from "@/components/inputs/textInput";
import { ModelSelection } from "@/components/inputs/modelSelection";
import { HowItWorksCard } from "@/components/cards/howItWorksCard";
import { AnalysisTip } from "@/components/cards/analysisTipCard";
import { useTextAnalysis } from "@/hooks/useTextAnalysis";
import { ResultsAreaWithFeedback } from '@/components/analysis/ResultsAreaWithFeedback';

export default function TextAnalysis() {
  const [inputText, setInputText] = useState<string>('');
  const {
    results,
    isLoading,
    progress,
    analysisStatus,
    partialResults,
    handleAnalyze,
    resetResults,
    selectedModel,
    setSelectedModel
  } = useTextAnalysis();

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (inputText.trim()) {
      handleAnalyze(inputText);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <TextAnalysisHeader />
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-6">
        <div className="lg:col-span-2">
          <form onSubmit={handleFormSubmit} className="space-y-4">
            <TextInput
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
              isLoading={isLoading}
              onClear={() => {
                setInputText('');
                resetResults();
              }}
            />
            
            <div className="flex items-center justify-between">
              <ModelSelection
                selectedModel={selectedModel}
                onModelSelect={setSelectedModel}
                disabled={isLoading}
              />
              
              <Button type="submit" disabled={isLoading || !inputText.trim()}>
                {isLoading ? (
                  <>
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    Analyzing...
                  </>
                ) : (
                  <>Analyze Text</>
                )}
              </Button>
            </div>
          </form>
          
          <div className="mt-8">
            <ResultsAreaWithFeedback
              results={results as any}
              isLoading={isLoading}
              progress={progress}
              analysisStatus={analysisStatus}
              partialResults={partialResults as any}
              originalText={inputText}
            />
          </div>
        </div>
        
        <div>
          <HowItWorksCard />
          <AnalysisTip />
        </div>
      </div>
    </div>
  );
}
